import { useQuery } from '@tanstack/react-query';

type ObjectiveDto = {
  id: string;
  description: string;
  clientId: string;
  creationOrder?: number;
};

export function useClientObjectives(clientId?: string) {
  const { data, isLoading, error, refetch } = useQuery<ObjectiveDto[]>({
    queryKey: ['clients', clientId, 'objectives'],
    enabled: !!clientId,
  });

  return {
    objectives: data ?? [],
    isLoading,
    error,
    refetch,
  };
}
